import { createContext, Dispatch, SetStateAction } from "react";
import {
  BotCustomStrategyTargetsData,
  BotStrategySelectorData,
  CustomStrategyErrorData,
  StrategyTabs,
} from "@shared/features/bots/BotForm/common/types";
import {
  BuiltInStrategyData,
  ConfigurationItem,
  OrderTypes,
} from "@shared/types";

export const BotStrategiesContext = createContext<
  | {
      orderType: OrderTypes.ENTRY | OrderTypes.TAKE_PROFIT;
      numOrdersSelectorData?: BotStrategySelectorData;
      numActiveOrdersSelectorData?: BotStrategySelectorData;
      firstOrderPercentSelectorData?: BotStrategySelectorData;
      amountScaleSelectorData?: BotStrategySelectorData;
      priceDifferenceSelectorData?: BotStrategySelectorData;
      priceScaleSelectorData?: BotStrategySelectorData;
      baselineSelectorData?: BotStrategySelectorData;
      isCustomStrategy: boolean;
      isValid: boolean;
      isCustomStrategyValid: boolean;
      nameInputData: {
        value: string;
        onChange: Dispatch<SetStateAction<string>>;
        ref: React.RefObject<any>;
        error: string | undefined;
      };
      customStrategyErrors: CustomStrategyErrorData;
      numTargetsSelectorData: {
        shouldDisplay: boolean;
        opacity: number;
        value: number | undefined;
        onChange: Dispatch<SetStateAction<number | undefined>>;
        options: { value: number; label: string }[];
      };
      targetsData: BotCustomStrategyTargetsData;
      customStrategyModified: boolean;
      customStrategiesItem?: ConfigurationItem;
      dcaStrategiesItem?: ConfigurationItem;
      createCustomStrategyTemplate?: ConfigurationItem;
      createDcaStrategyTemplate?: ConfigurationItem;
      templateStrategies?: ConfigurationItem[];
      templateStrategy?: BuiltInStrategyData["builtin_strategy_type"];
      setTemplateStrategy: (
        templateStrategy?: BuiltInStrategyData["builtin_strategy_type"]
      ) => void;
      selectedTab?: StrategyTabs;
      tab?: StrategyTabs;
    }
  | undefined
>(undefined);
